import axios, { AxiosInstance } from 'axios';

export const getLauncherClientApi = (): AxiosInstance => {
  const apiClient = axios.create();
  apiClient.defaults.baseURL = process.env.LAUNCHER_API_URL || 'https://launcher.xsolla.com';
  apiClient.defaults.withCredentials = true;
  apiClient.defaults.validateStatus = (status) => status >= 200 && status < 300;

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    apiClient.defaults.headers.common.Authorization = `Bearer ${process.env.PUBLISHER_TOKEN}`;
  }

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        !error.response.config.url.includes(process.env.LAUNCHER_API_URL)
      ) {
        const interceptorError = {
          code: '999-999',
          description: 'Invalid token.'
        };
        error.response.data.error = interceptorError; // eslint-disable-line no-param-reassign
      }

      return Promise.reject(error);
    }
  );

  return apiClient;
};

export const launcherApi = getLauncherClientApi();
